export default {
  // 服务人员查订单列表
  serviceOrderList: [],
  // 日志列表
  serviceLogList: [],
  // 配置参数
  serviceConfigObj: {},
  // 详情
  serviceLogDetail: {}
}
